module.exports = __webpack_public_path__ + "img/Velo.0ae426ac.png";